import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from '../../environments/environment';
import { ApiService } from 'app/api.service';
import { HubService } from 'app/hub.service';
import { LoaderService } from 'app/loader.service';
import { Angulartics2 } from 'angulartics2';
import { DatatableComponent } from '@swimlane/ngx-datatable/src/components/datatable.component';
declare var $: any;

@Component({
  selector: 'app-mydata',
  templateUrl: './mydata.component.html',
  styleUrls: ['./mydata.component.scss']
})
export class MydataComponent implements OnInit {

  sessionsList: any = [];
  summariesList: any = [];
  userRoles: any = [];
  @ViewChild('table') table: DatatableComponent;

  constructor(
    public apiService: ApiService,
    private loaderService: LoaderService,
    private hubService: HubService,
    private angulartics2: Angulartics2
  ) { }

  ngOnInit() {
    if(this.apiService.Parse.User.current().id){
      this.getRoles(this.apiService.Parse.User.current().id);
    }else{
      console.log("Role NA");
    }
    this.loaderService.setLoading();
    this.getAllSummaryData();
  }

  /**
  * ---------------------------------------------
  * Format and download the sessions list
  *
  * @param {string} `format` i.e. 'csv' or 'json'
  * ---------------------------------------------
  */
  downloadSummaries(format='csv'){
    // track the event
    this.angulartics2.eventTrack.next({ action: 'Export Summary History', properties: { category: 'MyData', label: format } });
    // convert and download the summary data
    this.convert(this.summariesList, format);
  }

  /**
  * ---------------------------------------------
  * Get all sessions for the currently logged in user
  *
  * @param {string} `format` i.e. 'csv' or 'json'
  * ---------------------------------------------
  */
  getAllSummaryData(){
    let where = {
      "user": {
        className: "_User",
        objectId: this.apiService.Parse.User.current().id,
        __type: "Pointer"
      }
    }
    let includes = ['sessionSummary', 'user'];
    let limit = 1500;
    let skip = null;
    let order = '-startDate';

    this.hubService.getResource('RideSession', where, limit, skip, order, includes).subscribe(
      sessions => {
        this.sessionsList = sessions;

        for (let i = 0; i < sessions.length; i++) {
          if(sessions[i].sessionSummary){
            this.summariesList.push(
              {
                "objectId": sessions[i].objectId,
                "startDate": sessions[i].startDate.iso,
                "title": sessions[i].title,
                "energy": sessions[i].sessionSummary.energy,
                "pesRightLegCoefficient": sessions[i].sessionSummary.pesRightLegCoefficient,
                "speedAvg": sessions[i].sessionSummary.speedAvg,
                "cadenceAvg": sessions[i].sessionSummary.cadenceAvg,
                "balanceAvg": sessions[i].sessionSummary.balanceAvg,
                "powerMax": sessions[i].sessionSummary.powerMax,
                "anglePeakForceRightAvg": sessions[i].sessionSummary.anglePeakForceRightAvg,
                "time": sessions[i].sessionSummary.time,
                "anglePeakForceLeftNewtonsAvg": sessions[i].sessionSummary.anglePeakForceLeftNewtonsAvg,
                "powerAvg": sessions[i].sessionSummary.powerAvg,
                "speedMax": sessions[i].sessionSummary.speedMax,
                "anglePeakForceRightNewtonsAvg": sessions[i].sessionSummary.anglePeakForceRightNewtonsAvg,
                "pesLeftLegCoefficient": sessions[i].sessionSummary.pesLeftLegCoefficient,
                "revolutionsCount": sessions[i].sessionSummary.revolutionsCount,
                "pesCombinedCoefficient": sessions[i].sessionSummary.pesCombinedCoefficient,
                "cadenceMax": sessions[i].sessionSummary.cadenceMax,
                "distance": sessions[i].sessionSummary.distance,
                "anglePeakForceLeftAvg": sessions[i].sessionSummary.anglePeakForceLeftAvg
              }
            );
          }
        }

        this.loaderService.setLoaded();

      },
      error => {
        // console.log(error);
      }
    );
  }

  /**
  * ---------------------------------------------
  * Get the revolutions file
  *
  * @param {string} `file` wbsr file name
  * @param {string} `format` i.e. 'csv' or 'json'
  * ---------------------------------------------
  */
  getRevolutionData(file, format='csv'){

    // track the event
    this.angulartics2.eventTrack.next({ action: 'Export Revolutions File', properties: { category: 'MyData', label: format } });

    // get the file
    this.hubService.getFile(file).subscribe(
      file => {

        // Build the formatted array and then output in the desired format
        this.buildOutputArray(file).then(value => {
          this.convert(value, format, file.startDate);
        });

      },
      error => {
        // console.log(error);
      });

  }

  /**
  * ---------------------------------------------
  * Build an array which is used to output the data
  *
  * @param {array} `revolutions`
  * @return {array}
  * ---------------------------------------------
  */
  buildOutputArray(file){

    return new Promise(resolve => {

      let revList = [];

      if (file.laps){ // full wbs file

        file.revolutions = [];
        for (let i = 0; i < file.laps.length; i++) {
          for (let j = 0; j < file.laps[i].data.length; j++) {

            let tmpRev = {
              "time": file.laps[i].data[j].time,
              "heartrate": file.laps[i].data[j].heartrate,
              "balance": file.laps[i].data[j].balance,
              "force": file.laps[i].data[j].force,
              "power": file.laps[i].data[j].power,
              "speed": file.laps[i].data[j].speed,
              "distance": file.laps[i].data[j].distance,
              "cadence": file.laps[i].data[j].cadence,

            };

            // we dont always have pes data
            if(file.laps[i].data[j].pes){
              tmpRev['pesCombinedCoefficient'] = file.laps[i].data[j].pes.combinedCoefficient;
              tmpRev['pesRightCoefficient'] = file.laps[i].data[j].pes.rightCoefficient;
              tmpRev['pesLeftCoefficient'] = file.laps[i].data[j].pes.leftCoefficient;
            }else{
              console.log("no pes data");
              tmpRev['pesCombinedCoefficient'] = 'na';
              tmpRev['pesRightCoefficient'] = 'na';
              tmpRev['pesLeftCoefficient'] = 'na';
            }

            // special case for Boardman Performance Centre
            if(this.userRoles.includes("Boardman")){
              // tmpRev['polar'] = file.laps[i].data[j].polar;
              if(file.laps[i].data[j].polar){
                tmpRev['polarForces'] = file.laps[i].data[j].polar.force;
                tmpRev['polarLeftCount'] = file.laps[i].data[j].polar.lcnt;
                tmpRev['polarTotalCount'] = file.laps[i].data[j].polar.cnt;
              }else{
                console.log("no polar data");
                tmpRev['polarForces'] = 'na';
                tmpRev['polarLeftCount'] = 'na';
                tmpRev['polarTotalCount'] = 'na';
              }

            }

            revList.push(tmpRev);
          }
        }
        resolve(revList);
      }else{ // ~200 rev wbsr file
        for (let i = 0; i < file.revolutions; i++) {
          revList.push(
            {
              "time": file.revolutions[i].time,
              "distance": file.revolutions[i].distance,
              "balance": file.revolutions[i].balance,
              "force": file.revolutions[i].force,
              "power": file.revolutions[i].power,
              "speed": file.revolutions[i].speed,
              "cadence": file.revolutions[i].cadence,
              "heartrate": file.revolutions[i].heartrate
            }
          );
        }
        resolve(revList);
      }

    })
  }

  /**
  * ---------------------------------------------
  * Convert the array to csv etc
  *
  * @param {array} `data` array of json objects
  * @param {string} `format` i.e. 'csv' or 'json'
  * ---------------------------------------------
  */
  convert(data, format='csv', filenameSuffix=''){
    if(format === 'csv'){
      const replacer = (key, value) => value === null ? '' : value; // handle null values
      const header = Object.keys(data[0]);
      let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
      csv.unshift(header.join(','));
      csv = csv.join('\r\n');
      // console.log(csv);
      this.export(csv, 'csv', filenameSuffix);
    }else if (format === 'json'){
      this.export(data, 'json', filenameSuffix);
    }else if (format === 'tcx'){
      this.export(data, 'tcx', filenameSuffix);
    }
  }

  /**
  * ---------------------------------------------
  * Force the file download
  *
  * @param {string} `data` i.e. string contents for the txt file
  * @param {string} `format` i.e. 'csv' or 'json'
  * ---------------------------------------------
  */
  export(data, format, filenameSuffix) {

    // Build file name
    let now = new Date();
    const dateString = now.toISOString().substring(0, 10);
    if(filenameSuffix == ''){filenameSuffix = dateString;}
    let firstName = this.apiService.Parse.User.current().get("firstName") ? this.apiService.Parse.User.current().get("firstName") : "";
    let lastName = this.apiService.Parse.User.current().get("lastName") ? this.apiService.Parse.User.current().get("lastName") : "";

    const filename = "WB-HUB" + '-' + firstName.toUpperCase() +'-' + lastName.toUpperCase() + "-" + filenameSuffix + '.' + format

    // stringify content
    if(format === 'json'){
      data = JSON.stringify(data);
    }

    let blob = new Blob([data], { type: 'text/' + format });
    let url = window.URL.createObjectURL(blob);

    // trigger a download
    if (navigator.msSaveOrOpenBlob) {
      navigator.msSaveBlob(blob, filename);
    } else {
      let a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
    window.URL.revokeObjectURL(url);
  }

  /**
  * ---------------------------------------------
  * Track
  * - 'action' is not sending with Angulartics2 when
  * - used in html, so hacking this together to do it
  * @param {string} `action` e.g. 'Export Revolutions File'
  * @param {string} `category` e.g. 'MyData' (quite often this is the title of the page)
  * @param {string} `label` e.g. 'tcx' - used to differentiate an action so for file export this may be the file type requested
  * ---------------------------------------------
  */
  track(action, category, label){
    // track the event
    this.angulartics2.eventTrack.next({ action: action, properties: { category: category, label: label } });
  }

  /**
  * ---------------------------------------------
  * Get a user's roles
  * i.e. this.getRoles(this.apiService.Parse.User.current().id);
  * @param {string} `userId` - objectId of user
  * ---------------------------------------------
  */

  getRoles(userId) {
    // roles to check
    const rolesToCheck = ['Admin', 'Boardman', 'Staff', 'Army', 'User'];

    for (let i = 0; i < rolesToCheck.length; i++) {
      let where = { "users": { "__type": "Pointer", "className": "_Users", "objectId": userId }, "name": rolesToCheck[i] };

      this.hubService.getResource('_Role', where, 1, null, null, null)
        .subscribe(
        response => {
          this.userRoles.push(rolesToCheck[i]);
        },
        error => {
          console.log("error:", error);
        }
      );

    }
 
    return;

  }

}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/mydata/mydata.component.ts